import React from 'react';
import styled from 'styled-components';
import { StarSVG,HalfStarSVG,EmptyStarSVG } from '../../../../FlyfishComponents/flyfishIcons/icons';
  type Props = {
	userRating;
	width?;
	height?;
	customClassName?;
  }

  const Rating = ({ value, maxRating,width,height }) => {
	const stars = [];
  
	for (let i = 1; i <= maxRating; i++) {
	  if (i <= value) {
		stars.push(<StarSVG key={i} width={width} height={height}/>);
	  } else if (i - 0.5 === value) {
		stars.push(<HalfStarSVG key={i} width={width} height={height}/>);
	  } else {
		stars.push(<EmptyStarSVG key={i} width={width} height={height}/>);
	
	  }
	}
  
	return <div className="rating" style={{display:'flex',justifyContent:'space-between',width:'fit-content'}}>{stars}</div>;
  };
  
const StyleAdvisorContainer = styled.div`
&.ff-style-rating{
	>.ff-chatbot-body1{
        font-size:11px !important;
		@media (max-width: 600px){
			font-size:14px !important;
		}
	}
	
}
}
  `
const EcomStarRating = ({userRating,width,height,customClassName}:Props) => {
	
	const maxRating = 5;
  
	return (
	  <StyleAdvisorContainer className={customClassName} style={{display:'flex',alignItems:'center'}}>
		<div className='ff-chatbot-body1' style={{marginRight:'3px',fontWeight:'500'}}>{userRating.toFixed(1)}</div>
		<Rating value={userRating} maxRating={maxRating} width={width} height={height}/>
	  </StyleAdvisorContainer>
	);
};

export default EcomStarRating;
